export default __webpack_public_path__ + "static/media/0.1ea5bccd.jpg";